import Model from '@/lib/data/Model';
// import FormQuestion from './FormQuestion';
import FileStorageItem from './FileStorageItem';
import RiskImprovementLog from './RiskImprovementLog';

class RiskImprovement extends Model {
    static idProperty = 'id';

    fields = [
        { name: 'id' },
        { name: 'form_ques_data_id' },
        { name: 'ri_no' },
        { name: 'factor' },
        { name: 'heading' },
        { name: 'ri_description' },
        { name: 'category' },
        { name: 'priority' },
        { name: 'ri_comment' },
        { name: 'def_comment' },
        { name: 'cost_estimate' },
        { name: 'cost_actual' },
        { name: 'risk_rating_impact' },
        { name: 'risk_rating_at_survey' },
        { name: 'risk_rating_mitigated' },
        { name: 'eml_block' },
        { name: 'question' },
        // {
        //     name: 'question',
        //     association: {
        //         type: 'one',
        //         model: FormQuestion,
        //     },
        // },
        {
            name: 'files',
            association: {
                type: 'many',
                model: FileStorageItem,
                collectionConfig: {
                    url: '/riskimprovement/files/list',
                },
            },
        },
        {
            name: 'risk_improvement_log_list',
            association: {
                type: 'many',
                model: RiskImprovementLog,
            },
        },

        { name: 'same_as_cnle' },
        { name: 'building_ratio' },
        { name: 'plant_equipment_ratio' },
        { name: 'stock_ratio' },
        { name: 'other_ratio' },
        { name: 'estimated_bi' },
        { name: 'status' },
        {
            name: 'loss_estimate',
            type: 'jsonb',
            defaultValue: { tsi: {}, prieml: {}, eml: {}, cnle: {}, tnle: {} },
        },
        /* Not persistent */
        { name: 'ri_class' },
    ];

    /**
     * Create the User object
     *
     * @param {Object} data - Seed data for this object.
     */
    constructor(data) {
        super(data);
        this.init();
    }

    get shortStatus() {
        // get the first letter of each word
        return this.status?.match(/\b(\w)/g).join('');
    }

    get lossEstimate() {
        // get the first letter of each word
        return this.loss_estimate || { tsi: {}, prieml: {}, eml: {}, cnle: {}, tnle: {} };
    }

    api = [
        {
            name: 'create',
            method: 'POST',
            url: '/visit/riskimprovement/save',
        },
        {
            name: 'update',
            method: 'POST',
            url: '/visit/riskimprovement/save',
            params: [
                'id',
                'agreement_name',
                'start_date',
                'end_date',
                'due_date',
                'status',
                'underwriter_id',
                'invoice_currency_id',
            ],
        },
    ];
}

export default RiskImprovement;
